import { Eye, EyeClosed, Info, WalletCards } from 'lucide-react';
import React, { useState } from 'react'


interface CardWalletProps {
    income: number;
    onGet?: () => void;
}

const CardWallet = ({ income = 0, onGet }: CardWalletProps) => {
    const [showIncome, setShowIncome] = useState(false)
    const formattedIncome = new Intl.NumberFormat('id-ID').format(income);
    return (
        <article className="shadowCard w-full p-3 flex flex-col gap-3">
            <h3 className='title2medium capitalize'>Saldo komisi</h3>
            <div className="text-text-blue-100 inline-flex gap-3 items-center ">
                <div className="flex-2">
                    <p className='h5bold w-full'>Rp {showIncome ? `${formattedIncome}` : '*********'}</p>
                </div>
                <button type='button' className='flex-auto'
                    onClick={() => setShowIncome(prev => !prev)}>
                    {showIncome ? <Eye /> : <EyeClosed />}
                </button>
            </div>
            <div className="bg-text-blue-10 p-3 inline-flex rounded-[8px] gap-3 items-start">
                <Info className='text-text-blue-100' />
                <span className='reg12 lg:text-[16px]'>Minimal penarikan sebesar Rp 50.000. Bebas biaya penarikan.</span>
            </div>
        </article>
    )
}


export default CardWallet